import { baseApi as api } from "../baseApi";
export const addTagTypes = ["Account"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAccount: build.query<GetAccountApiResponse, GetAccountApiArg>({
        query: () => ({ url: `/api/v1/account` }),
        providesTags: ["Account"],
      }),
      updateAccount: build.mutation<
        UpdateAccountApiResponse,
        UpdateAccountApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/account`,
          method: "PUT",
          body: queryArg.updateAccountForm,
        }),
        invalidatesTags: ["Account"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as accountApi };
export type GetAccountApiResponse = /** status 200 OK */ AccountData;
export type GetAccountApiArg = void;
export type UpdateAccountApiResponse = /** status 200 OK */ AccountData;
export type UpdateAccountApiArg = {
  updateAccountForm: UpdateAccountForm;
};
export type AccountData = {
  /** Business name, shown to customers */
  displayName?: string;
  /** True until the vendor has given a business name */
  needsName?: boolean;
  /** E.164 */
  phone?: string;
  userId?: number;
};
export type UpdateAccountForm = {
  /** Shown to customers in their order chats */
  displayName?: string;
};
export const {
  useGetAccountQuery,
  useLazyGetAccountQuery,
  useUpdateAccountMutation,
} = injectedRtkApi;
